var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.122,
    height: 50.264,
    viewBox: "0 0 49.122 50.264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65859",
    "data-name": "Group 65859",
    transform: "translate(-1245.481 -583.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34100",
    "data-name": "Path 34100",
    d: "M61.421,286.592a25.161,25.161,0,0,0,17.1,2.988,1.387,1.387,0,0,0-.075-2.743c-.17-.02-.344-.044-.514-.071-.621-.051-1.237-.13-1.854-.237a19.58,19.58,0,0,1-14.517-27.053,3.008,3.008,0,0,0-4.778-3.427,18.263,18.263,0,0,0-3.557,4.4c-5.928,10.276-.862,20.927,8.177,26.144Z",
    transform: "translate(1195.275 343.378)",
    fill: "#f60",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34101",
    "data-name": "Path 34101",
    d: "M60.7,219.034A25.145,25.145,0,0,0,49.564,232.35a1.387,1.387,0,0,0,2.411,1.308l.32-.4a18.682,18.682,0,0,1,1.134-1.5,19.572,19.572,0,0,1,30.686.956,3.008,3.008,0,0,0,5.359-2.427,18.429,18.429,0,0,0-2.043-5.268C81.5,214.75,69.74,213.817,60.7,219.038Z",
    transform: "translate(1196 367.171)",
    fill: "#52ce00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34102",
    "data-name": "Path 34102",
    d: "M133.538,253.437a25.168,25.168,0,0,0-5.964-16.3,1.387,1.387,0,0,0-2.34,1.439c.067.158.134.32.2.482.265.557.506,1.134.719,1.723a19.584,19.584,0,0,1-16.169,26.085,3.008,3.008,0,0,0-.577,5.881,18.317,18.317,0,0,0,5.581.866c11.857,0,18.552-9.719,18.552-20.157Z",
    transform: "translate(1161.065 354.649)",
    fill: "#2a7fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirename);
export default __webpack_public_path__ + "static/media/airename.a731fea3442df1945309c717f8329e79.svg";
export { ForwardRef as ReactComponent };